export default __webpack_public_path__ + "3869479843551836e9df989db5af7117.png";